module.exports = __webpack_public_path__ + "assets/img/Australian-Seniors-Landing-Page.d7fdbc6d.jpg";